export const CHOOSE_YOUR_OPTIONS_ACTIONS = 'ChooseYourOptionsActions';
export const CHOOSE_YOUR_OPTIONS_COMPONENT = 'ChooseYourOptions';
export const SCROLL_INLINE_CALENDAR = 'scroll-inline-calendar';
export const CHOOSE_YOURS_OPTIONS_DEAL = 'choose-your-options-deal';
export const SCROLL_TO_MAP_LOCATION = 'scroll-to-map-location';
export const REVIEWS_COMPONENT = 'reviewsComponent';
export const AMENITIE_COMPONENT = 'amenitiesComponent';
export const DROPDOWN_PRODUCT_PAGE = 'dropdownProductPage';
